import type { ReactElement } from 'react';
import { Link } from 'react-router';

/**
 * 로그인하지 않은 채 마이페이지로 온 경우.
 *
 * 404 로 튕기지 않는다 — 여기까지 온 사람은 이미 회원일 가능성이 높고,
 * 아니라면 자료를 받으러 온 사람이다. 둘 다 길을 열어 준다.
 */
export function SignedOutNotice(): ReactElement {
  return (
    <div className="u-container flex max-w-[30rem] flex-col items-center gap-5 py-24 text-center">
      <h1 className="text-[1.375rem] font-bold tracking-[-0.04em]">로그인이 필요합니다</h1>
      <p className="text-[14px] leading-[1.8] text-muted-foreground">
        받으신 자료와 수신 설정은 로그인 후에 보실 수 있습니다.
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Link
          to="/login"
          className="inline-flex h-11 items-center rounded-md bg-primary px-5 text-sm font-semibold text-primary-foreground hover:bg-primary/85"
        >
          로그인
        </Link>
        <Link
          to="/library"
          className="inline-flex h-11 items-center rounded-md border border-foreground px-5 text-sm font-medium"
        >
          자료 먼저 보기
        </Link>
      </div>
    </div>
  );
}
